import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import moment from 'moment'
import 'moment/locale/de' 

import Backend from 'i18next-xhr-backend'
import LanguageDetector from 'i18next-browser-languagedetector'

i18n
	.use(Backend)
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
        lng: 'en',
		fallbackLng: ['en'],
        debug: false,
        backend: { loadPath: './locales/{{lng}}/{{ns}}.json', crossDomain: true },
		interpolation: {
			escapeValue: false, // not needed for react as it escapes by default
		}
    })
    
i18n.on('languageChanged', newlocale => {
    moment.locale(newlocale)
})

export default i18n